// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"fd9a9d3d","388":"6350a831","739":"0e117d9e"}[chunkId] + ".chunk.js";
};